// extracted by mini-css-extract-plugin
export default {"banner":"FreeOrderBanner_banner__e33yL"};